// initial state
import * as types from "../mutation-types";
import subscriptionService from "../../api/subscription-service";

const state = {
  modified: false,
  puzzleOrders: []
}

// getters
const getters = {
  getAllPuzzleOrders: (state) => {
    return state.puzzleOrders
  },
  getModifiedPuzzleOrder: (state) => {
    return state.modified
  },
  getPuzzleOrders: (state) => {
    let keys = Object.keys(state.puzzleOrders)
    keys.sort((a, b) => {return parseInt(a) - parseInt(b)}).reverse();
    let sortedPuzzleOrders = new Array();
    keys.forEach(key => {
      sortedPuzzleOrders.push(state.puzzleOrders[key]);
    });
    return sortedPuzzleOrders;
  },
  getCurrentOrders: (state, rootState) => {
    let currentPlan = rootState.getCurrentPlan;
    let currentPuzzleOrders = new Array();
    if (currentPlan.attributes.hasNextDayShipping) {
      Object.values(state.puzzleOrders).forEach(value => {
        if (value.attributes.status == "assigned" || value.attributes.status == "fulfilled" || value.attributes.status == "queued_to_ship") {
          currentPuzzleOrders.push(value);
        }
      })
    } else{
      Object.values(state.puzzleOrders).forEach(value => {
        if (value.attributes.status == "assigned" || value.attributes.status == "fulfilled" || value.attributes.status == "queued_to_ship" || value.attributes.status == "return_in_transit") {
          currentPuzzleOrders.push(value);
        }
      })
    }

    return currentPuzzleOrders;
  },
  hasOpenOrders: (state) => {
    let flag = false;
    Object.values(state).forEach(value => {
      if (value.attributes.status == "open") {
        flag = true;
      }
    })
    return flag;
  }
}

const actions = {
  setPuzzleOrders(store, puzzleOrders) {
    store.commit(types.SET_PUZZLE_ORDERS, puzzleOrders);
  },
  updatePuzzleFeedback(store, puzzleOrder){
    store.commit(types.MODIFY_PUZZLE_ORDER)
    subscriptionService.updatePuzzleOrderFeedback(puzzleOrder, data => {
      store.commit(types.UPDATE_PUZZLE_ORDER, data.puzzleOrders[Object.keys(data.puzzleOrders)[0]]);
      store.commit(types.SUCCESS, "Your Feedback Was Submitted!");
    })
  }
}

// mutations
const mutations = {
  [types.SET_PUZZLE_ORDERS] (state, puzzle_orders ) {
    state.puzzleOrders = puzzle_orders
  },
  [types.UPDATE_PUZZLE_ORDERS] (state, puzzleOrders ) {
    Object.keys(puzzleOrders).forEach(key => {
      this._vm.$set(this.state.puzzleOrders,  key, puzzleOrders[key])
    });

  },
  [types.MODIFY_PUZZLE_ORDER] (state ) {
    state.modified = true
  },
  [types.UPDATE_PUZZLE_ORDER] (state, puzzleOrder ) {
    Object.keys(state.puzzleOrders).forEach(key => {
      if (puzzleOrder.id == key){
        state.puzzleOrders[key] = puzzleOrder
        state.modified = false
      }
    });

  },
}

export default {
  state,
  getters,
  actions,
  mutations
}